import { render, staticRenderFns } from "./McqQuestion.vue?vue&type=template&id=ea0cd428&scoped=true&"
import script from "./McqQuestion.vue?vue&type=script&lang=js&"
export * from "./McqQuestion.vue?vue&type=script&lang=js&"
import style0 from "./McqQuestion.vue?vue&type=style&index=0&id=ea0cd428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0cd428",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRadioGroup,VRow})
